export default __webpack_public_path__ + "static/media/black-multi-knob.2c923d4b.png";